import { Resource, Service } from 'ngx-jsonapi';
import { IDocumentResource } from 'ngx-jsonapi/lib/interfaces/data-object';

export class JsonapiWebsocketHelper {
    public isResource(eventData: any): boolean {
        return eventData && eventData.data && typeof eventData.data !== 'string' && eventData.data.id && eventData.data.type;
    }

    public generateResourceFromEvent(eventData: any): Resource {
        const documentData: IDocumentResource = eventData as IDocumentResource;

        return this.createResourceFromDocumentData(documentData);
    }

    public processWebSocketEvent(eventData: any): any {
        if (!eventData || !eventData.data || !Array.isArray(eventData.data) || eventData.data.length === 0) {
            return null;
        }
        const hasValidResources: boolean = eventData.data.every((item: any) => item && typeof item === 'object' && item.type && item.id);

        if (!hasValidResources) {
            return null;
        }

        return this.processResourcesEvent(eventData);
    }

    public processResourcesEvent(eventData: any): any {
        if (!eventData || !eventData.data || !Array.isArray(eventData.data)) {
            return { eventData: [] };
        }

        const response: Array<Resource> = [];

        eventData.data.forEach((systemDocument: any) => {
            const documentData: IDocumentResource = { data: systemDocument } as IDocumentResource;
            response.push(this.createResourceFromDocumentData(documentData));
        });

        return {
            eventData: response
        };
    }

    private createResourceFromDocumentData(documentData: IDocumentResource): Resource {
        const service: Service = new Service();
        service.register();
        service.type = documentData.data.type;

        const resource: Resource = service.getOrCreateResource(documentData.data.id);
        resource.fill(documentData);

        return resource;
    }
}
